import axios from 'axios';
import { apiBaseUrl } from '../config/env';

const http = axios.create({
  baseURL: apiBaseUrl,
  timeout: 10000
});

http.interceptors.response.use(
  (response) => response.data,
  (error) => Promise.reject(error)
);

export default http;
